import { useState } from 'react';
import Organization from 'infrastructure/Organization';

export const useBanner = (key) => {
  const [isBannerOpen, setIsBannerOpen] = useState(Organization.getSelectedOrg()[key] || false);
  const onClose = () => setIsBannerOpen(false);

  return [isBannerOpen, onClose];
};
